module.exports = __webpack_public_path__ + "static/screenshot2-84dddd85a827ea22ff3783b4154e9304.jpg";